import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useActivitiesEnabled = (): boolean => {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    supabase
      .from("site_content")
      .select("value")
      .eq("key", "ui.activities_enabled")
      .eq("lang", "global")
      .maybeSingle()
      .then(({ data }) => {
        if (data) setEnabled(data.value !== "false");
      });
  }, []);

  return enabled;
};